<template>
  <b-modal
    ref="modal"
    :title="$t('common.post_complaint')"
    modal-class="spdo-modal"
    hide-header-close
    hide-footer
    centered
    size="md"
    @hide="$emit('input', false)"
  >
    <v-form
      v-if="complaint.parts.length"
      @submit.prevent="postComplaint"
    >
      <div class="v-application spdo-modal__body ">
        <b-row>
          <b-col>
            <div class="input-block input-block_white">
              <label class="input-block__label grey--text">
                {{ $t('common.orders.complaint_code') }}
              </label>
              <v-text-field
                v-model="complaint.complaintCode"
                autocomplete="off"
                hide-details
                solo
              />
            </div>
          </b-col>
          <b-col>
            <div class="input-block input-block_white">
              <label class="input-block__label grey--text">
                {{ $t('common.dealer_act_number') }}
              </label>
              <v-text-field
                v-model="complaint.dealerActNumber"
                autocomplete="off"
                hide-details
                solo
              />
            </div>
          </b-col>
        </b-row>
        <h5>
          Позиции
        </h5>
        <div
          v-for="(it, i) in partsSelected"
          :key="i"
          class="mb-4"
        >
          <div class="mb-2">
            {{ it.name }}
          </div>
          <div class="input-block input-block_white">
            <b-row>
              <b-col cols="2">
                <label class="input-block__label grey--text mb-1">
                  {{ $t('common.quantity') }}
                </label>
                <v-text-field
                  v-model.number="complaint.parts[i].postComplaintQuantity"
                  type="number"
                  min="1"
                  :max="complaint.parts[i].quantity - complaint.parts[i].complaintQuantity"
                  step="1"
                  hide-details
                  autocomplete="off"
                  solo
                />
              </b-col>
              <b-col offset="2">
                <div
                  v-if="complaint.parts[i].complaintQuantity"
                  class="mb-2"
                >
                  Уже подано рекламаций по деталям в позиции: {{ complaint.parts[i].complaintQuantity }}
                </div>
                <div>
                  Всего деталей этого типа в заказе: {{ complaint.parts[i].quantity }}
                </div>
              </b-col>
            </b-row>
            <div
              v-if="complaint.parts[i].complaintQuantity + complaint.parts[i].postComplaintQuantity > complaint.parts[i].quantity"
              class="mb-4 red--text"
            >
              Превышено количество номенклатуры в заказе
            </div>
          </div>
        </div>
        <label>
          {{ $t('views.file_list.select_complaint_pictures') }}
        </label>
        <div class="complaint-images-container">
          <input
            v-show="false"
            ref="file"
            type="file"
            multiple
            accept="image/x-png,image/jpeg"
            @change="uploadFiles"
          >
          <v-btn
            type="button"
            color="primary"
            outlined
            :loading="imageLoader"
            :disabled="loading"
            class="mb-2"
            @click="setFiles"
          >
            {{ complaint.photos.length ?
              $t('views.file_list.select_files') :
              $t('views.file_list.add_files') }}
          </v-btn>
          <div class="complaint-images">
            <img
              v-for="photo in complaint.photos"
              :key="photo.fileId"
              :src="photo.fileUrl"
            >
          </div>
        </div>
        <div
          v-if="imageError"
          class="red--text"
        >
          {{ imageError }}
        </div>

        <div
          v-for="(it, i) in complaint.waybills"
          :key="`w-${i}`"
          class="input-block input-block_white"
        >
          <b-row>
            <b-col>
              <label class="input-block__label grey--text">
                {{ $t('common.orders.waybills_number') }}
              </label>
              <v-text-field
                v-model="it.number"
                autocomplete="off"
                hide-details
                solo
              />
            </b-col>
            <b-col>
              <label class="input-block__label grey--text">
                {{ $t('common.orders.waybills_date') }}
              </label>
              <date-picker
                v-model="it.date"
                output="Z"
                hide-details
                solo
              />
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="v-application d-flex">
        <v-btn
          class="flex-grow-1 mr-4 "
          outlined
          large
          @click="$refs.modal.hide()"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          class="flex-grow-1"
          :loading="loading"
          :disabled="disabled"
          outlined
          large
          type="submit"
        >
          {{ $t('common.send') }}
        </v-btn>
      </div>
    </v-form>
  </b-modal>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import DatePicker from '@/components/common/DatePicker';

export default {
  name: 'PostComplaintModal',
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      required: true,
    },
    partsSelected: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    loading: false,
    partIndex: null,
    complaint: {
      complaintCode: '',
      dealerActNumber: '',
      parts: [],
      waybills: [{
        number: '',
        date: '',
      }],
      photos: [],
    },
    imageError: '',
    imageLoader: false,
  }),
  computed: {
    complaintParams() {
      return {
        ...this.complaint,
        orderId: this.orderId,
        parts: this.complaint.parts.map((it) => ({
          orderPositionId: it._id,
          quantity: it.postComplaintQuantity,
        })),
        photos: this.complaint.photos.map((img) => ({
          fileName: img.fileName,
          fileId: img.fileId,
        })),
      };
    },
    disabled() {
      return this.complaint.photos.length < 3 || !!this.imageError
      || !this.complaint.complaintCode
      || !this.complaint.dealerActNumber
      || this.complaint.parts.some((it) => it.quantity < 1)
      || this.complaint.parts.some((it) => it.complaintQuantity + it.postComplaintQuantity > it.quantity)
      || this.complaint.waybills.some((it) => !it.number || !it.date);
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.updateForm();
        this.$refs.modal.show();
      } else {
        this.file = null;
        this.$emit('input', false);
      }
    },
  },
  methods: {
    updateForm() {
      Object.assign(this.$data.complaint, this.$options.data().complaint);
      this.complaint.parts = JSON.parse(JSON.stringify(this.partsSelected)).map((it) => ({
        ...it,
        postComplaintQuantity: 1,
        complaintQuantity: it.complaintQuantity || 0,
      }));
      this.complaint.photos = [];
    },
    uploadFiles() {
      this.complaint.photos = [];
      const { files } = this.$refs.file;
      this.imageLoader = true;

      Promise.all(Object.keys(files).map(async (key) => this.uploadFile(key))).finally(() => {
        this.validateFiles();
        this.imageLoader = false;
      });
    },
    async uploadFile(i) {
      return new Promise((resolve, reject) => {
        const { files } = this.$refs.file;
        const file = files[i];
        const fileId = uuidv4();
        const { name, type, size } = file;

        const reader = new FileReader();
        reader.onload = async () => {
          await this.$http.post('containers/file', reader.result, {
            headers: {
              container: 'complaint-images',
              file: fileId,
              'Content-Type': type,
            },
          });

          this.complaint.photos.push({
            fileName: name,
            fileId,
            fileUrl: URL.createObjectURL(file),
            size,
          });
          resolve();
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },
    async setFiles() {
      this.$refs.file.value = null;
      this.$refs.file.click();
    },
    validateFiles() {
      if (this.complaint.photos.some((photo) => photo.size > 5242880)) {
        this.imageError = this.$t('common.orders.img_size_error');
        return;
      }

      if (this.complaint.photos.length < 3) {
        this.imageError = this.$t('common.orders.img_length_error');
        return;
      }

      this.imageError = '';
    },
    async postComplaint() {
      this.loading = true;
      await this.$http.post('complaints', this.complaintParams).finally(() => {
        this.loading = false;
      });
      this.$refs.modal.hide();
      this.$emit('postComplaint');
    },
  },
};
</script>
